export default __webpack_public_path__ + "static/PayPerks_Loop-3b8de45d485f63a82226a3522d4babc3.webm";